import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { store } from './auth/store';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import i18n from './i18n'; // Import i18n configuration
import { I18nextProvider } from 'react-i18next'; // Import I18nextProvider



// Replace 'your_stripe_public_key' with your actual Stripe public key
const stripePromise = loadStripe('your_stripe_public_key');

ReactDOM.render(
    <Provider store={store}>
        <Elements stripe={stripePromise}>
            <I18nextProvider i18n={i18n}> {/* Wrap the App component with I18nextProvider */}
                <React.StrictMode>
                    <App />
                </React.StrictMode>
            </I18nextProvider>
        </Elements>
    </Provider>,
    document.getElementById('root')
);

reportWebVitals();
